import EnumService from '../EnumService'

export default class SituacaoEnumService extends EnumService{

    constructor(){
        super('enumSituacao');
    }
  
  }